import { takeLatest, put, call } from 'redux-saga/effects';

import { TAction } from 'shared/types';
import PatientConversationService from 'shared/services/PatientConversationService';
import { IPatientConversation } from 'shared/interfaces/patientConversation.interface';
import {
  getPatientConversationData,
  getUnreadCount,
  setPatientConversationData,
  setPatientConversationDataFail,
  setTotalUnreadMessages
} from './chat.redux';

function* getPatientConversationSaga({
  payload
}: TAction<{ patientId: string; affiliateId: string }>) {
  try {
    console.log('ssss', payload);

    const result: IPatientConversation = yield call(
      PatientConversationService.getPatientConversation,
      payload
    );

    yield put(setPatientConversationData(result));
  } catch (error) {
    yield put(setPatientConversationDataFail());
    console.log('getPatientConversationChannelsSaga error', error);
  }
}

function* getUnreadCountSaga({ payload }: TAction<{ affiliateId: string }>) {
  try {
    const result: { unread_count: number } = yield call(
      PatientConversationService.getUnreadCount,
      payload
    );

    yield put(setTotalUnreadMessages(result.unread_count));
  } catch (error) {
    console.log('getPatientConversationChannelsSaga error', error);
  }
}

function* PatientConversation() {
  yield takeLatest(getPatientConversationData.type, getPatientConversationSaga);
  yield takeLatest(getUnreadCount.type, getUnreadCountSaga);
}

export default PatientConversation;
